










import { Component, Prop, Vue } from 'vue-property-decorator';
import { IdealoShopModel } from '@/models/Idealo';

@Component
export default class IdealoShop extends Vue {
  @Prop() private shopInfo!: IdealoShopModel;
  @Prop() private active!: boolean;
  @Prop({ default: false }) private small!: boolean;
  private clicked() {
    this.$emit('chosen');
  }
}
